import {initAccordion} from "./components";

jQuery(initCarousels)

function initCarousels() {
  initDefaultCarousel()
  initToggleContentCarousel()
}

function initDefaultCarousel() {
  const $carousels = jQuery(".default-carousel");
  if ($carousels.length === 0) return;

  $carousels.each(function() {
    const swiper = new Swiper(this, {
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        addIcons: false
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.2,
        }
      }
    });
  });
}

function initToggleContentCarousel() {
  const $carousels = jQuery(".toggle-card-carousel");
  if ($carousels.length === 0) return;

  $carousels.each(function() {
    const swiper = new Swiper(this, {
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        addIcons: false
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.2,
        }
      }
    });

    const $accordions = jQuery(this).find(".accordion-wrapper")
    $accordions.each(function () {
      initAccordion(jQuery(this))
    })

    jQuery($accordions).each(function () {
      const $openBtn = jQuery(this).find(".open-btn")

      $openBtn.on("click", function () {
        jQuery(this).parents(".toggle-card-gradient-bg").toggleClass("open")
      })
    })

  });
}
